window.addEventListener('load', function () {
  if (typeof gsap === 'undefined') {
    console.warn('GSAP library missing from layout rendering flow.');
    return;
  }

  const sliderSection = document.querySelector('.hero-slider-section');
  if (!sliderSection) return;

  const slides = sliderSection.querySelectorAll('.hero-slide');
  const dots = sliderSection.querySelectorAll('.slider-dot');
  const totalSlides = slides.length;
  if (totalSlides <= 1) return;

  let currentSlideIndex = 0;
  let autoplayTimer = null;
  
  const isAutoplay = sliderSection.getAttribute('data-autoplay') === 'true';
  const autoplaySpeed = parseInt(sliderSection.getAttribute('data-speed'), 10) || 5000;

  // Initialize data hook on main parent for dot CSS styling matches
  sliderSection.setAttribute('data-active-index', '0');

  // Staggered assets animation timeline logic
  function runSlideAnimation(activeSlide) {
    const bgImage = activeSlide.querySelector('.slide-bg-image');
    const canImg = activeSlide.querySelector('.center-product-image');
    const logoImg = activeSlide.querySelector('.behind-logo-element');

    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    // Reset properties for current slide components
    gsap.set([bgImage, canImg, logoImg], { clearProps: "all" });

    // Sequence Line 1: Background scales out/fades in
    tl.fromTo(bgImage, 
      { alpha: 0, scale: 1.12 }, 
      { alpha: 1, scale: 1, duration: 1.0 }
    );

    // Sequence Line 2: Soda Can pops upward smoothly
    tl.fromTo(canImg, 
      { alpha: 0, y: 140, scale: 0.85 }, 
      { alpha: 1, y: 0, scale: 1, duration: 0.85, ease: "back.out(1.1)" },
      "-=0.5"
    );

    // Sequence Line 3: Behind Can Logo grows out from center
    if (logoImg) {
      tl.fromTo(logoImg, 
        { alpha: 0, scale: 0.3, transformOrigin: "center center" }, 
        { alpha: 1, scale: 1, duration: 0.65, ease: "back.out(1.5)" },
        "-=0.4"
      );
    }
  }

  function goToSlide(index) {
    if (index === currentSlideIndex) return;

    const oldSlide = slides[currentSlideIndex];
    
    if (index >= totalSlides) {
      currentSlideIndex = 0;
    } else if (index < 0) {
      currentSlideIndex = totalSlides - 1;
    } else {
      currentSlideIndex = index;
    }

    const nextSlide = slides[currentSlideIndex];

    // Update parent theme dataset for dynamic color shifting indicators
    sliderSection.setAttribute('data-active-index', currentSlideIndex.toString());

    // Outbound clean animation sweep
    gsap.to(oldSlide, { 
      alpha: 0, 
      duration: 0.4, 
      onComplete: () => {
        oldSlide.classList.remove('active');
        gsap.set(oldSlide, { clearProps: "all" });
      }
    });

    // Inbound presentation trigger handling
    nextSlide.classList.add('active');
    gsap.fromTo(nextSlide, { alpha: 0 }, { alpha: 1, duration: 0.4 });
    
    // Fire isolated visual components animation flow
    runSlideAnimation(nextSlide);

    // Track state on active common nav points updates
    dots.forEach(dot => {
      if (parseInt(dot.getAttribute('data-slide-to'), 10) === currentSlideIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    if (isAutoplay) startAutoplay();
  }

  function startAutoplay() {
    stopAutoplay();
    autoplayTimer = setInterval(() => {
      goToSlide(currentSlideIndex + 1);
    }, autoplaySpeed);
  }

  function stopAutoplay() {
    if (autoplayTimer) clearInterval(autoplayTimer);
  }

  // Intercept shared interactive tracks click routing loops
  sliderSection.addEventListener('click', function (e) {
    const dotButton = e.target.closest('.slider-dot');
    if (dotButton) {
      e.preventDefault();
      const targetIndex = parseInt(dotButton.getAttribute('data-slide-to'), 10);
      goToSlide(targetIndex);
    }
  });

  // Execute stage 1 timeline on landing sequence instantly
  runSlideAnimation(slides[0]);

  if (isAutoplay) {
    startAutoplay();
  }
});